import styled from 'styled-components';

interface Props {
  option: string;
  children: React.ReactNode;
  onClose: () => void;
}
const titleMap: Record<string, string> = {
  region: '지역 설정',
  court: '법원 선택',
  totalCategory: '물건종류',
  progressStatus: '진행단계',
  saleDateStart: '매각기일',
  saleDateEnd: '매각기일',
  approvalDateStart: '사용승인',
  approvalDateEnd: '사용승인',
  bidno: '유찰횟수',
};

function OptionModal({ option, children, onClose }: Props) {
  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
        option={option}
      >
        <TitleBox>
          <Spacer />
          <Title>{titleMap[option]}</Title>
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="닫기"
            width={24}
            onClick={onClose}
          />
        </TitleBox>
        <Content>{children}</Content>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default OptionModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div<{ option?: string }>`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #00000040;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  height: ${({ option }) =>
    option !== 'saleDateStart' &&
    option !== 'saleDateEnd' &&
    option !== 'approvalDateStart' &&
    option !== 'approvalDateEnd' &&
    '640px'};
  display: flex;
  flex-direction: column;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`;
const Spacer = styled.div`
  width: 24px;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
`;
